<div role="button" class="card card-padding-{{ cardPadding }}"
     [attr.aria-label]="ariaLabel"
     [tabIndex]="disabled ? -1 : tabindex"
     [class.card-order]="isInfoTitleLast"
     [ngClass]="{'disabled': disabled, 'selected': selected, 'card-action-wrapper': showDropdownActions}"
     (keyup)="onKeyUp($event)"
     (click)="onElementClick($event)">
    <app-status-label *ngIf="disabled"
                      [cssClasses]="'status-label__gray status-label__disabled-status status-label__top-right'"
                      [icon]="'code'"
                      [statusLabelText]="'GENERAL.IN_DEVELOPMENT' | translate">
    </app-status-label>
    <div *ngIf="cardInfo" class="card__info">
        <span *ngIf="cardInfoTitleIcon" class="card__info__icon">
            <img src="assets/images/icons/{{ cardInfoTitleIcon }}.svg" alt="icon-{{ cardInfoTitleIcon }}">
        </span>

        <span *ngIf="cardInfoTitle" class="card__info__title">{{ cardInfoTitle }}</span>
    </div>
    <div *ngIf="showDropdownActions" class="card__action-button">
        <app-dropdown-button
                [triggerData]="triggerData"
                [menuItems]="menuItems"
                (click)="openMenu()"
                (buttonEvent)="buttonMenuAction($event)">
        </app-dropdown-button>
    </div>
    <h5 *ngIf="cardMainTitle" class="card__title">{{ cardMainTitle }}</h5>
    <p *ngIf="cardParagraph" class="card__paragraph"> {{ cardParagraph }}</p>
</div>
